import { render, staticRenderFns } from "./CardWidget.vue?vue&type=template&id=7b4ba26e&scoped=true&"
import script from "./CardWidget.vue?vue&type=script&lang=js&"
export * from "./CardWidget.vue?vue&type=script&lang=js&"
import style0 from "./CardWidget.vue?vue&type=style&index=0&id=7b4ba26e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b4ba26e",
  null
  
)

export default component.exports